import { create } from 'zustand'
import { settingsDb } from '../db/database'
import { DEFAULT_SURVEYOR } from '../utils/constants'

const useSettingsStore = create((set, get) => ({
  defaultSurveyor: DEFAULT_SURVEYOR,
  openaiApiKey: '',
  isOnline: navigator.onLine,
  loading: false,
  error: null,

  // Load settings from database
  loadSettings: async () => {
    set({ loading: true, error: null })
    try {
      const defaultSurveyor = await settingsDb.get('defaultSurveyor') || DEFAULT_SURVEYOR
      const openaiApiKey = await settingsDb.get('openaiApiKey') || ''

      set({
        defaultSurveyor,
        openaiApiKey,
        loading: false
      })
    } catch (error) {
      set({ error: error.message, loading: false })
      console.error('Failed to load settings:', error)
    }
  },

  // Update default surveyor
  setDefaultSurveyor: async (name) => {
    set({ loading: true, error: null })
    try {
      await settingsDb.set('defaultSurveyor', name)
      set({ defaultSurveyor: name, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
      console.error('Failed to update surveyor:', error)
      throw error
    }
  },

  // Update OpenAI API key
  setOpenaiApiKey: async (apiKey) => {
    set({ loading: true, error: null })
    try {
      await settingsDb.set('openaiApiKey', apiKey)
      set({ openaiApiKey: apiKey, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
      console.error('Failed to update API key:', error)
      throw error
    }
  },

  // Update online status
  setOnlineStatus: (isOnline) => {
    set({ isOnline })
  },

  // Check if API key is configured
  hasApiKey: () => {
    return get().openaiApiKey.length > 0
  },

  // Clear error
  clearError: () => set({ error: null })
}))

// Listen for online/offline events
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    useSettingsStore.getState().setOnlineStatus(true)
  })

  window.addEventListener('offline', () => {
    useSettingsStore.getState().setOnlineStatus(false)
  })
}

export default useSettingsStore
